import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const documentsJourneyRoutes = [
  {
    id: 'documents-view-home',
    trackingName: 'Documents View Home',
    path: 'dl/view/documents',
    loader: async ({ context }) => {
      context?.browserNavigate('/account/documents')
    },
  },
] as const satisfies JourneyRoute[]
